import controller from './kform-builder-element.controller';
import kformElementComponent from '~/components/kform/element/kform-element.component';

const kformBuilderElementComponent = {
	...kformElementComponent,
	controller,
};

export default kformBuilderElementComponent;
